import { render, staticRenderFns } from "./layoutMain.vue?vue&type=template&id=60235f11&scoped=true&"
import script from "./layoutMain.vue?vue&type=script&lang=js&"
export * from "./layoutMain.vue?vue&type=script&lang=js&"
import style0 from "./layoutMain.vue?vue&type=style&index=0&id=60235f11&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60235f11",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tsunagaru-v3-app-mintenant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60235f11')) {
      api.createRecord('60235f11', component.options)
    } else {
      api.reload('60235f11', component.options)
    }
    module.hot.accept("./layoutMain.vue?vue&type=template&id=60235f11&scoped=true&", function () {
      api.rerender('60235f11', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/src/components/layouts/layoutMain.vue"
export default component.exports